/* SES Palma · núcleo B2B compartido (página de pedidos + portal de clientes).
   i18n, formato de precios y fechas, cliente de Supabase con la sesión en sessionStorage,
   acceso con email + contraseña, diálogos accesibles y avisos.
   Expone window.SESB2B. Nada personal se guarda en la URL ni en localStorage. */
(function () {
  'use strict';

  const LANGS = ['es', 'en', 'fr', 'it'];
  const LANG_KEY = 'ses_lang_v1';
  const LOCALES = { es: 'es-ES', en: 'en-GB', fr: 'fr-FR', it: 'it-IT' };
  const AUTH_STORAGE_KEY = 'ses-b2b-auth';
  const COMPANY_KEY = 'ses_b2b_company';
  const VIEWAS_KEY = 'ses_b2b_viewas';
  const GROUP_KEY = 'ses_b2b_group';
  const ACCESS_MAILTO = 'mailto:antonio@sespalma.com?subject=Acceso%20mayoristas%20SES%20Palma';
  const MIN_PASSWORD = 10;

  /* ---------- i18n ---------- */
  const DICT = {
    cancel:        { es: 'Cancelar', en: 'Cancel', fr: 'Annuler', it: 'Annulla' },
    ok:            { es: 'Aceptar', en: 'OK', fr: 'OK', it: 'OK' },
    close:         { es: 'Cerrar', en: 'Close', fr: 'Fermer', it: 'Chiudi' },
    va_btn:        { es: 'Ver como…', en: 'View as…', fr: 'Voir en tant que…', it: 'Vedi come…' },
    va_title:      { es: 'Ver el portal como una empresa', en: 'View the portal as a company', fr: 'Voir le portail en tant que société', it: 'Vedi il portale come un\'azienda' },
    va_help:       { es: 'Verás lo mismo que su comprador, con sus precios y documentos. Solo lectura: no se puede pedir ni aceptar en su nombre.', en: 'You will see exactly what their buyer sees, with their prices and documents. Read-only: you cannot order or accept on their behalf.', fr: 'Vous verrez la même chose que leur acheteur, avec leurs prix et documents. Lecture seule : impossible de commander ou d\'accepter en leur nom.', it: 'Vedrai lo stesso del loro buyer, con prezzi e documenti. Sola lettura: non puoi ordinare né accettare a loro nome.' },
    va_search:     { es: 'Buscar empresa', en: 'Search company', fr: 'Rechercher une société', it: 'Cerca azienda' },
    va_count:      { es: '{n} empresas', en: '{n} companies', fr: '{n} sociétés', it: '{n} aziende' },
    va_none:       { es: 'Ninguna empresa coincide', en: 'No company matches', fr: 'Aucune société ne correspond', it: 'Nessuna azienda corrisponde' },
    va_banner:     { es: 'Viendo como', en: 'Viewing as', fr: 'Vue en tant que', it: 'Vista come' },
    va_on_behalf:  { es: 'pedidos en su nombre', en: 'ordering on their behalf', fr: 'commandes en son nom', it: 'ordini a suo nome' },
    va_change:     { es: 'Cambiar', en: 'Change', fr: 'Changer', it: 'Cambia' },
    va_exit:       { es: 'Salir', en: 'Exit', fr: 'Quitter', it: 'Esci' },
    retry:         { es: 'Reintentar', en: 'Try again', fr: 'Réessayer', it: 'Riprova' },
    lang_group:    { es: 'Idioma', en: 'Language', fr: 'Langue', it: 'Lingua' },
    wholesale_tag: { es: 'Mayoristas', en: 'Wholesale', fr: 'Revendeurs', it: 'Rivenditori' },
    acc_login:     { es: 'Acceder', en: 'Sign in', fr: 'Connexion', it: 'Accedi' },
    acc_account:   { es: 'Mi cuenta', en: 'My account', fr: 'Mon compte', it: 'Il mio account' },
    acc_logout:    { es: 'Salir', en: 'Sign out', fr: 'Déconnexion', it: 'Esci' },
    acc_order:     { es: 'Hacer pedido', en: 'Place order', fr: 'Commander', it: 'Ordina' },
    logged_out:    { es: 'Has cerrado sesión.', en: 'You have signed out.', fr: 'Vous êtes déconnecté.', it: 'Sei uscito.' },
    auth_title:    { es: 'Acceso mayoristas', en: 'Wholesale access', fr: 'Accès revendeurs', it: 'Accesso rivenditori' },
    auth_intro:    { es: 'Entra con el email y la contraseña de tu cuenta para ver tus precios y hacer pedidos.', en: 'Sign in with your account email and password to see your prices and place orders.', fr: 'Connectez-vous avec l\'e-mail et le mot de passe de votre compte pour voir vos prix et commander.', it: 'Accedi con email e password del tuo account per vedere i tuoi prezzi e ordinare.' },
    auth_email:    { es: 'Email', en: 'Email', fr: 'E-mail', it: 'Email' },
    auth_password: { es: 'Contraseña', en: 'Password', fr: 'Mot de passe', it: 'Password' },
    auth_show:     { es: 'Mostrar', en: 'Show', fr: 'Afficher', it: 'Mostra' },
    auth_hide:     { es: 'Ocultar', en: 'Hide', fr: 'Masquer', it: 'Nascondi' },
    auth_show_pw:  { es: 'Mostrar contraseña', en: 'Show password', fr: 'Afficher le mot de passe', it: 'Mostra password' },
    auth_submit:   { es: 'Entrar', en: 'Sign in', fr: 'Se connecter', it: 'Accedi' },
    auth_signing:  { es: 'Entrando…', en: 'Signing in…', fr: 'Connexion…', it: 'Accesso…' },
    auth_forgot:   { es: '¿Has olvidado tu contraseña?', en: 'Forgot your password?', fr: 'Mot de passe oublié ?', it: 'Hai dimenticato la password?' },
    auth_request:  { es: '¿Aún no eres cliente? Solicita acceso', en: 'Not a stockist yet? Request access', fr: 'Pas encore revendeur ? Demandez un accès', it: 'Non sei ancora rivenditore? Richiedi l\'accesso' },
    auth_bad:      { es: 'Email o contraseña incorrectos.', en: 'Incorrect email or password.', fr: 'E-mail ou mot de passe incorrect.', it: 'Email o password non corretti.' },
    auth_need:     { es: 'Escribe tu email y tu contraseña.', en: 'Enter your email and password.', fr: 'Saisissez votre e-mail et votre mot de passe.', it: 'Inserisci email e password.' },
    auth_email_bad:{ es: 'Revisa el email: no parece válido.', en: 'Check the email: it does not look valid.', fr: 'Vérifiez l\'e-mail : il ne semble pas valide.', it: 'Controlla l\'email: non sembra valida.' },
    auth_forgot_title: { es: 'Restablecer la contraseña', en: 'Reset your password', fr: 'Réinitialiser le mot de passe', it: 'Reimposta la password' },
    auth_forgot_help:  { es: 'Te enviaremos un enlace para crear una contraseña nueva.', en: 'We will send you a link to create a new password.', fr: 'Nous vous enverrons un lien pour créer un nouveau mot de passe.', it: 'Ti invieremo un link per creare una nuova password.' },
    auth_forgot_send:  { es: 'Enviar enlace', en: 'Send link', fr: 'Envoyer le lien', it: 'Invia link' },
    auth_forgot_sent:  { es: 'Si el email tiene una cuenta, recibirás un enlace en unos minutos. Revisa también la carpeta de spam.', en: 'If the email has an account, you will receive a link within a few minutes. Check your spam folder too.', fr: 'Si l\'e-mail a un compte, vous recevrez un lien d\'ici quelques minutes. Vérifiez aussi les spams.', it: 'Se l\'email ha un account, riceverai un link entro pochi minuti. Controlla anche lo spam.' },
    auth_back:     { es: 'Volver a entrar', en: 'Back to sign in', fr: 'Retour à la connexion', it: 'Torna all\'accesso' },
    auth_reset_title: { es: 'Nueva contraseña', en: 'New password', fr: 'Nouveau mot de passe', it: 'Nuova password' },
    auth_set_title:{ es: 'Crea tu contraseña', en: 'Create your password', fr: 'Créez votre mot de passe', it: 'Crea la tua password' },
    auth_set_help: { es: 'Mínimo 10 caracteres. Usa una frase que recuerdes.', en: 'At least 10 characters. Use a phrase you will remember.', fr: 'Au moins 10 caractères. Choisissez une phrase facile à retenir.', it: 'Almeno 10 caratteri. Usa una frase facile da ricordare.' },
    auth_new_pw:   { es: 'Contraseña nueva', en: 'New password', fr: 'Nouveau mot de passe', it: 'Nuova password' },
    auth_new_pw2:  { es: 'Repite la contraseña', en: 'Repeat the password', fr: 'Répétez le mot de passe', it: 'Ripeti la password' },
    auth_set_save: { es: 'Guardar contraseña', en: 'Save password', fr: 'Enregistrer', it: 'Salva password' },
    auth_pw_short: { es: 'La contraseña debe tener al menos 10 caracteres.', en: 'The password must be at least 10 characters long.', fr: 'Le mot de passe doit contenir au moins 10 caractères.', it: 'La password deve avere almeno 10 caratteri.' },
    auth_pw_mismatch: { es: 'Las dos contraseñas no coinciden.', en: 'The two passwords do not match.', fr: 'Les deux mots de passe ne correspondent pas.', it: 'Le due password non coincidono.' },
    auth_pw_saved: { es: 'Contraseña guardada. Ya has entrado.', en: 'Password saved. You are signed in.', fr: 'Mot de passe enregistré. Vous êtes connecté.', it: 'Password salvata. Hai effettuato l\'accesso.' },
    auth_pw_weak:  { es: 'Esa contraseña es demasiado común. Prueba con otra más larga.', en: 'That password is too common. Try a longer one.', fr: 'Ce mot de passe est trop courant. Essayez-en un plus long.', it: 'Questa password è troppo comune. Provane una più lunga.' },
    auth_link_expired: { es: 'El enlace ha caducado o ya se usó. Pide uno nuevo.', en: 'The link has expired or was already used. Request a new one.', fr: 'Le lien a expiré ou a déjà été utilisé. Demandez-en un nouveau.', it: 'Il link è scaduto o è già stato usato. Richiedine uno nuovo.' },
    auth_link_invalid: { es: 'El enlace no es válido o ha caducado. Pide uno nuevo aquí abajo.', en: 'The link is not valid or has expired. Request a new one below.', fr: 'Le lien n\'est pas valide ou a expiré. Demandez-en un nouveau ci-dessous.', it: 'Il link non è valido o è scaduto. Richiedine uno nuovo qui sotto.' },
    auth_no_session: { es: 'Abre de nuevo el enlace del correo para crear la contraseña.', en: 'Open the link in the email again to create your password.', fr: 'Ouvrez à nouveau le lien de l\'e-mail pour créer le mot de passe.', it: 'Apri di nuovo il link dell\'email per creare la password.' },
    auth_rate:     { es: 'Demasiados intentos. Espera un minuto y vuelve a probar.', en: 'Too many attempts. Wait a minute and try again.', fr: 'Trop de tentatives. Attendez une minute et réessayez.', it: 'Troppi tentativi. Attendi un minuto e riprova.' },
    auth_offline:  { es: 'No hay conexión. Revisa la red y vuelve a probar.', en: 'No connection. Check your network and try again.', fr: 'Pas de connexion. Vérifiez le réseau et réessayez.', it: 'Nessuna connessione. Controlla la rete e riprova.' },
    auth_unavailable: { es: 'El acceso no está disponible ahora mismo. Inténtalo en unos minutos.', en: 'Sign-in is not available right now. Try again in a few minutes.', fr: 'La connexion n\'est pas disponible pour le moment. Réessayez dans quelques minutes.', it: 'L\'accesso non è disponibile al momento. Riprova tra qualche minuto.' },
    // errores de las RPC del portal (el mensaje de la excepción es el código)
    err_stale_version:   { es: 'Hay una versión más reciente de este pedido. La hemos cargado: revísala antes de seguir.', en: 'There is a newer version of this order. We have loaded it: review it before continuing.', fr: 'Il existe une version plus récente de cette commande. Nous l\'avons chargée : vérifiez-la avant de continuer.', it: 'Esiste una versione più recente di questo ordine. L\'abbiamo caricata: controllala prima di continuare.' },
    err_missing_price:   { es: 'Hay artículos sin precio para tu cuenta. Quítalos o escríbenos.', en: 'Some items have no price for your account. Remove them or contact us.', fr: 'Certains articles n\'ont pas de prix pour votre compte. Retirez-les ou contactez-nous.', it: 'Alcuni articoli non hanno prezzo per il tuo account. Rimuovili o scrivici.' },
    err_not_your_turn:   { es: 'Ahora no te toca responder a este pedido. Hemos actualizado su estado.', en: 'It is not your turn on this order. We have refreshed its status.', fr: 'Ce n\'est pas à vous de répondre sur cette commande. Son statut a été mis à jour.', it: 'Ora non tocca a te su questo ordine. Abbiamo aggiornato lo stato.' },
    err_forbidden:       { es: 'Tu cuenta no tiene permiso para esta acción.', en: 'Your account does not have permission for this action.', fr: 'Votre compte n\'a pas l\'autorisation pour cette action.', it: 'Il tuo account non ha il permesso per questa azione.' },
    err_not_found:       { es: 'No encontramos este pedido.', en: 'We could not find this order.', fr: 'Commande introuvable.', it: 'Ordine non trovato.' },
    err_not_editable:    { es: 'Este pedido ya no se puede editar.', en: 'This order can no longer be edited.', fr: 'Cette commande n\'est plus modifiable.', it: 'Questo ordine non è più modificabile.' },
    err_not_cancellable: { es: 'Este pedido ya no se puede cancelar.', en: 'This order can no longer be cancelled.', fr: 'Cette commande ne peut plus être annulée.', it: 'Questo ordine non può più essere annullato.' },
    err_invalid_store:   { es: 'Elige una tienda de entrega válida.', en: 'Choose a valid delivery store.', fr: 'Choisissez une boutique de livraison valide.', it: 'Scegli un negozio di consegna valido.' },
    err_invalid_lines:   { es: 'El pedido tiene líneas no válidas.', en: 'The order has invalid lines.', fr: 'La commande contient des lignes non valides.', it: 'L\'ordine contiene righe non valide.' },
    err_invalid_qty:     { es: 'Hay una cantidad no válida (máximo 9999).', en: 'There is an invalid quantity (maximum 9999).', fr: 'Une quantité n\'est pas valide (maximum 9999).', it: 'C\'è una quantità non valida (massimo 9999).' },
    err_invalid_sku:     { es: 'Hay un artículo no válido en el pedido.', en: 'There is an invalid item in the order.', fr: 'Un article de la commande n\'est pas valide.', it: 'C\'è un articolo non valido nell\'ordine.' },
    err_duplicate_sku:   { es: 'Un artículo aparece dos veces en el pedido.', en: 'An item appears twice in the order.', fr: 'Un article apparaît deux fois dans la commande.', it: 'Un articolo compare due volte nell\'ordine.' },
    err_empty_order:     { es: 'El pedido no tiene unidades.', en: 'The order has no units.', fr: 'La commande ne contient aucune unité.', it: 'L\'ordine non ha unità.' },
    err_too_many_lines:  { es: 'El pedido tiene demasiadas líneas.', en: 'The order has too many lines.', fr: 'La commande contient trop de lignes.', it: 'L\'ordine ha troppe righe.' },
    err_terms_required:  { es: 'Tienes que aceptar las condiciones de venta.', en: 'You must accept the terms of sale.', fr: 'Vous devez accepter les conditions de vente.', it: 'Devi accettare le condizioni di vendita.' },
    err_missing_idem_key:{ es: 'No se pudo preparar el envío. Vuelve a intentarlo.', en: 'The order could not be prepared. Try again.', fr: 'L\'envoi n\'a pas pu être préparé. Réessayez.', it: 'Non è stato possibile preparare l\'invio. Riprova.' },
    err_rate_limited:    { es: 'Demasiadas operaciones seguidas. Espera un poco y vuelve a intentarlo.', en: 'Too many attempts in a row. Wait a little and try again.', fr: 'Trop d\'opérations à la suite. Patientez un peu et réessayez.', it: 'Troppe operazioni di seguito. Attendi un po\' e riprova.' },
    err_invalid_line:    { es: 'Hay una línea no válida en el pedido. Revisa las cantidades (máximo 9999).', en: 'There is an invalid line in the order. Check the quantities (maximum 9999).', fr: 'Une ligne de la commande n\'est pas valide. Vérifiez les quantités (maximum 9999).', it: 'C\'è una riga non valida nell\'ordine. Controlla le quantità (massimo 9999).' },
    err_one_store_required: { es: 'Elige una sola tienda de entrega para este pedido.', en: 'Choose a single delivery store for this order.', fr: 'Choisissez une seule boutique de livraison pour cette commande.', it: 'Scegli un solo negozio di consegna per questo ordine.' },
    err_terms_outdated:  { es: 'Las condiciones de venta han cambiado. Recarga la página para leer las nuevas y aceptarlas.', en: 'The terms of sale have changed. Reload the page to read and accept the new ones.', fr: 'Les conditions de vente ont changé. Rechargez la page pour lire et accepter les nouvelles.', it: 'Le condizioni di vendita sono cambiate. Ricarica la pagina per leggere e accettare le nuove.' },
    err_season_closed:   { es: 'Los pedidos de esta temporada están cerrados.', en: 'Orders for this season are closed.', fr: 'Les commandes de cette saison sont closes.', it: 'Gli ordini di questa stagione sono chiusi.' },
    err_deadline_passed: { es: 'El plazo para enviar pedidos de esta temporada ha terminado. Escríbenos si necesitas algo.', en: 'The deadline for orders this season has passed. Contact us if you need anything.', fr: 'La date limite des commandes de cette saison est passée. Contactez-nous si besoin.', it: 'Il termine per gli ordini di questa stagione è scaduto. Scrivici se ti serve qualcosa.' },
    err_idempotency_conflict: { es: 'El pedido ha cambiado desde el último intento. Revísalo y vuelve a enviarlo.', en: 'The order changed since the last attempt. Review it and send it again.', fr: 'La commande a changé depuis la dernière tentative. Vérifiez-la et renvoyez-la.', it: 'L\'ordine è cambiato dall\'ultimo tentativo. Controllalo e invialo di nuovo.' },
    err_missing_expected_version: { es: 'Falta la versión del pedido. Recarga la página y vuelve a intentarlo.', en: 'The order version is missing. Reload the page and try again.', fr: 'La version de la commande manque. Rechargez la page et réessayez.', it: 'Manca la versione dell\'ordine. Ricarica la pagina e riprova.' },
    err_stale_prices:    { es: 'Tus precios se están actualizando. Inténtalo dentro de un rato o escríbenos.', en: 'Your prices are being updated. Try again later or contact us.', fr: 'Vos prix sont en cours de mise à jour. Réessayez plus tard ou contactez-nous.', it: 'I tuoi prezzi sono in aggiornamento. Riprova più tardi o scrivici.' },
    err_mixed_currency:  { es: 'El pedido mezcla monedas distintas. Escríbenos y lo revisamos.', en: 'The order mixes different currencies. Contact us and we will review it.', fr: 'La commande mélange plusieurs devises. Contactez-nous.', it: 'L\'ordine mescola valute diverse. Scrivici e lo controlliamo.' },
    err_too_many_drafts: { es: 'Tienes demasiados borradores abiertos. Envía o cancela alguno antes de guardar otro.', en: 'You have too many open drafts. Send or cancel one before saving another.', fr: 'Vous avez trop de brouillons ouverts. Envoyez-en ou annulez-en un avant d\'en enregistrer un autre.', it: 'Hai troppe bozze aperte. Invia o annulla qualcuna prima di salvarne un\'altra.' },
    err_signing_failed:  { es: 'No se pudo preparar la descarga. Vuelve a intentarlo.', en: 'The download could not be prepared. Try again.', fr: 'Le téléchargement n\'a pas pu être préparé. Réessayez.', it: 'Non è stato possibile preparare il download. Riprova.' },
    err_session_expired: { es: 'Tu sesión ha caducado. Vuelve a entrar.', en: 'Your session has expired. Sign in again.', fr: 'Votre session a expiré. Reconnectez-vous.', it: 'La sessione è scaduta. Accedi di nuovo.' },
    err_network:         { es: 'No hay conexión con el servidor. Revisa la red y vuelve a probar.', en: 'Cannot reach the server. Check your network and try again.', fr: 'Impossible de joindre le serveur. Vérifiez le réseau et réessayez.', it: 'Impossibile raggiungere il server. Controlla la rete e riprova.' },
    err_unknown:         { es: 'Algo ha fallado. Vuelve a intentarlo en unos minutos.', en: 'Something went wrong. Try again in a few minutes.', fr: 'Une erreur est survenue. Réessayez dans quelques minutes.', it: 'Qualcosa non ha funzionato. Riprova tra qualche minuto.' },
  };
  const ERROR_CODES = ['stale_version', 'missing_price', 'not_your_turn', 'forbidden', 'not_found', 'not_editable',
    'not_cancellable', 'invalid_store', 'invalid_lines', 'invalid_line', 'invalid_qty', 'invalid_sku', 'duplicate_sku', 'empty_order',
    'too_many_lines', 'terms_required', 'missing_idem_key', 'rate_limited', 'one_store_required', 'terms_outdated',
    'season_closed', 'deadline_passed', 'idempotency_conflict', 'missing_expected_version', 'stale_prices',
    'mixed_currency', 'too_many_drafts', 'signing_failed', 'already_received', 'invalid_date',
    'report_locked', 'invalid_period', 'empty_report',
    'invalid_details', 'missing_fields', 'too_many_versions', 'invalid_idempotency_key'];

  const lsGet = (k) => { try { return localStorage.getItem(k); } catch (_) { return null; } };
  const lsSet = (k, v) => { try { localStorage.setItem(k, v); } catch (_) { /* bloqueado */ } };
  const ssGet = (k) => { try { return sessionStorage.getItem(k); } catch (_) { return null; } };
  const ssSet = (k, v) => { try { sessionStorage.setItem(k, v); } catch (_) { /* bloqueado */ } };
  const ssDel = (k) => { try { sessionStorage.removeItem(k); } catch (_) { /* bloqueado */ } };
  // «Ver como…» se comparte entre pestañas (localStorage) y caduca a las 12 h: la página de pedidos
  // suele abrirse en otra pestaña y, sin esto, el admin pedía para su propia empresa sin darse cuenta.
  const VIEWAS_TTL = 12 * 3600 * 1000;
  const vaGet = () => {
    try {
      const v = JSON.parse(localStorage.getItem(VIEWAS_KEY) || 'null');
      if (v && v.id && v.until > Date.now()) return v.id;
      localStorage.removeItem(VIEWAS_KEY);
    } catch (_) { /* bloqueado o corrupto */ }
    return null;
  };
  const vaSet = (id) => { try { localStorage.setItem(VIEWAS_KEY, JSON.stringify({ id, until: Date.now() + VIEWAS_TTL })); } catch (_) { /* bloqueado */ } };
  const vaDel = () => { try { localStorage.removeItem(VIEWAS_KEY); } catch (_) { /* bloqueado */ } ssDel(VIEWAS_KEY); };

  function initialLang() {
    const saved = lsGet(LANG_KEY);
    if (LANGS.includes(saved)) return saved;
    const nav = (navigator.language || 'es').slice(0, 2).toLowerCase();
    return LANGS.includes(nav) ? nav : 'es';
  }

  let lang = initialLang();
  const langListeners = [];
  document.documentElement.lang = lang;

  function t(key, vars) {
    const e = DICT[key];
    let s = e ? (e[lang] || e.es || key) : key;
    if (vars) s = s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : m));
    return s;
  }
  function extend(dict) { Object.assign(DICT, dict); }
  function has(key) { return !!DICT[key]; }
  function getLang() { return lang; }
  function setLang(l) {
    if (!LANGS.includes(l) || l === lang) return;
    lang = l;
    lsSet(LANG_KEY, l);
    document.documentElement.lang = l;
    langListeners.forEach((fn) => { try { fn(l); } catch (e) { console.error(e); } });
    if (client) getSession().then(syncUserLang);
  }

  // El idioma del comprador se guarda en user_metadata.lang: los emails de la cola del servidor lo usan.
  let langSyncing = false;
  async function syncUserLang(session) {
    const c = client;
    if (!c || !session || !session.user || langSyncing) return;
    const meta = session.user.user_metadata || {};
    if (meta.lang === lang) return;
    langSyncing = true;
    try { await c.auth.updateUser({ data: { lang } }); } catch (_) { /* no bloquea: se reintenta en el siguiente cambio */ }
    langSyncing = false;
  }
  function onLang(fn) { langListeners.push(fn); }
  function locale() { return LOCALES[lang] || 'es-ES'; }

  /* ---------- formato ---------- */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // Valores del catálogo o del CRM que acaban en atributos o CSS: nunca se interpolan sin validar.
  // Color: solo #rgb, #rgba, #rrggbb o #rrggbbaa.
  function safeHex(v, fallback) {
    return /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(String(v || '')) ? String(v) : (fallback || '#cccccc');
  }
  // URL de imagen: https, o del mismo origen (assets del tema); data:image solo si se pide (generadas aquí).
  function safeUrl(v, opts) {
    if (typeof v !== 'string' || !v) return '';
    if (opts && opts.allowData && /^data:image\/(png|jpe?g|webp|gif);base64,[a-z0-9+/=]+$/i.test(v)) return v;
    try {
      const u = new URL(v, location.href);
      if (u.protocol === 'https:' || (u.origin === location.origin && /^https?:$/.test(u.protocol))) return u.href;
    } catch (_) { /* no es una URL válida */ }
    return '';
  }

  // «€59» si es entero, «€59,25» si tiene céntimos, en el idioma de la página. Nunca «€0»: devuelve ''.
  // Agrupa siempre los miles («€1.970,25»): en español Intl no agrupa los números de 4 cifras.
  // useGrouping 'always' donde existe; en navegadores antiguos se inserta el separador a mano.
  function groupSep() {
    try {
      const g = new Intl.NumberFormat(locale()).formatToParts(1000000).find((p) => p.type === 'group');
      return g ? g.value : '.';
    } catch (_) { return '.'; }
  }
  function forceGrouping(parts) {
    const sep = groupSep();
    return parts.map((p) => (p.type === 'integer' && p.value.length > 3 ? Object.assign({}, p, { value: p.value.replace(/\B(?=(\d{3})+(?!\d))/g, sep) }) : p));
  }
  function fmtPrice(n, currency) {
    const v = Number(n);
    if (n == null || n === '' || !isFinite(v) || v <= 0) return '';
    const cur = (currency || 'EUR').toUpperCase();
    const whole = Math.abs(v - Math.round(v)) < 0.005;
    let parts;
    try {
      parts = new Intl.NumberFormat(locale(), {
        style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2, useGrouping: 'always',
      }).formatToParts(whole ? Math.round(v) : v);
      parts = forceGrouping(parts);
    } catch (_) {
      return cur + ' ' + v.toFixed(whole ? 0 : 2);
    }
    const sym = (parts.find((p) => p.type === 'currency') || {}).value || cur;
    const num = parts.filter((p) => p.type !== 'currency' && p.type !== 'literal').map((p) => p.value).join('');
    return sym.length === 1 ? sym + num : sym + ' ' + num;
  }
  // Importes de documentos ya emitidos (un abono a cero es un dato real): admite 0 y negativos.
  function fmtAmount(n, currency) {
    const v = Number(n);
    if (n == null || !isFinite(v)) return '';
    if (v > 0) return fmtPrice(v, currency);
    const abs = fmtPrice(Math.abs(v) || 1, currency);
    return v === 0 ? abs.replace(/\d[\d.,  ]*/, '0') : '−' + abs;
  }
  function fmtInt(n) {
    try { return forceGrouping(new Intl.NumberFormat(locale(), { useGrouping: 'always' }).formatToParts(n)).map((p) => p.value).join(''); }
    catch (_) { return String(n); }
  }
  function parseDate(iso) {
    if (!iso) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
      const [y, m, d] = iso.split('-').map(Number);
      return new Date(y, m - 1, d);
    }
    const d = new Date(iso);
    return isNaN(d) ? null : d;
  }
  function fmtDate(iso, opts) {
    const d = parseDate(iso);
    if (!d) return '';
    return d.toLocaleDateString(locale(), opts || { day: 'numeric', month: 'short', year: 'numeric' });
  }
  function fmtDateTime(iso) {
    const d = parseDate(iso);
    if (!d) return '';
    return d.toLocaleString(locale(), { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }
  function countryName(cc) {
    if (!cc) return '';
    try { return new Intl.DisplayNames([locale()], { type: 'region' }).of(String(cc).toUpperCase()) || cc; }
    catch (_) { return cc; }
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    const b = new Uint8Array(16);
    crypto.getRandomValues(b);
    b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
    const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  }
  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim());

  /* ---------- enlace de invitación / recuperación ---------- */
  // Los enlaces llegan a /pages/b2b-cuenta?invite=1 o ?reset=1 con los tokens del flujo implícito
  // en el hash (#access_token=…&type=invite|recovery). Se leen ANTES de crear el cliente; el hash
  // se deja tal cual (o normalizado si venía detrás de una ruta «#/x#…») para que supabase-js lo consuma.
  const authRedirect = (function captureAuthRedirect() {
    const h = location.hash || '';
    const qp = new URLSearchParams(location.search);
    const qType = qp.get('invite') === '1' ? 'invite' : (qp.get('reset') === '1' ? 'recovery' : null);
    const at = h.search(/(access_token|error_description|error_code|error)=/);
    if (at < 0) return qType ? { type: qType, route: null, noTokens: true } : null;
    const params = new URLSearchParams(h.slice(at));
    const routeMatch = h.match(/^#(\/[^#&]*)/);
    const route = routeMatch ? routeMatch[1] : null;
    const base = location.pathname + location.search;
    if (params.get('error') || params.get('error_code')) {
      history.replaceState(null, '', base + (route ? '#' + route : ''));
      return { error: params.get('error_code') || params.get('error') || 'link_error', route, type: qType };
    }
    if (at > 1) history.replaceState(null, '', base + '#' + h.slice(at));
    return { type: params.get('type') || qType, route };
  })();
  // Quita ?invite / ?reset y los tokens de la URL una vez usados.
  function cleanAuthUrl(hash) {
    const u = new URL(location.href);
    u.searchParams.delete('invite');
    u.searchParams.delete('reset');
    history.replaceState(null, '', u.pathname + (u.search || '') + (hash || ''));
  }
  const needsPassword = !!(authRedirect && (authRedirect.type === 'invite' || authRedirect.type === 'recovery'));

  /* ---------- Supabase ---------- */
  let client = null;
  function supaConfig() {
    const c = window.SES_B2B_CONFIG || {};
    const d = (window.SES_DATA && window.SES_DATA.config && window.SES_DATA.config.supabase) || {};
    return { url: c.url || d.url, anonKey: c.anonKey || d.anonKey };
  }
  function sb() {
    if (client) return client;
    const c = supaConfig();
    if (!c.url || !c.anonKey || !window.supabase || !window.supabase.createClient) return null;
    let storage = null;
    try { storage = window.sessionStorage; } catch (_) { storage = null; }
    client = window.supabase.createClient(c.url, c.anonKey, {
      auth: {
        storage: storage || undefined,
        storageKey: AUTH_STORAGE_KEY,
        persistSession: !!storage,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'implicit',
      },
    });
    client.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT') { meCache = null; ssDel(COMPANY_KEY); vaDel(); ssDel(GROUP_KEY); }
      if (event === 'SIGNED_IN' || event === 'INITIAL_SESSION') setTimeout(() => syncUserLang(session), 0);
      authListeners.forEach((fn) => { try { fn(event, session); } catch (e) { console.error(e); } });
    });
    return client;
  }

  const authListeners = [];
  function onAuth(fn) { authListeners.push(fn); }

  async function getSession() {
    const c = sb();
    if (!c) return null;
    try {
      const { data } = await c.auth.getSession();
      return (data && data.session) || null;
    } catch (_) { return null; }
  }

  function authErrorCode(error) {
    if (!error) return null;
    const status = error.status || 0;
    const msg = String(error.message || '').toLowerCase();
    if (status === 429 || msg.includes('rate limit')) return 'auth_rate';
    if (msg.includes('failed to fetch') || msg.includes('network')) return 'auth_offline';
    if (msg.includes('weak') || msg.includes('pwned')) return 'auth_pw_weak';
    if (status >= 500) return 'auth_unavailable';
    return 'auth_bad';
  }

  async function signIn(email, password) {
    const c = sb();
    if (!c) return { ok: false, code: 'auth_unavailable' };
    try {
      const { error } = await c.auth.signInWithPassword({ email: String(email).trim().toLowerCase(), password });
      if (error) return { ok: false, code: authErrorCode(error) };
      meCache = null;
      return { ok: true };
    } catch (e) {
      return { ok: false, code: authErrorCode(e) };
    }
  }

  async function requestReset(email) {
    const c = sb();
    if (!c) return { ok: false, code: 'auth_unavailable' };
    try {
      // portal-recover responde siempre {ok:true}: no revela si el email tiene cuenta.
      // El enlace sale por la cola de emails del servidor, en el idioma del comprador.
      const { error } = await c.functions.invoke('portal-recover', { body: { email: String(email).trim().toLowerCase(), lang } });
      if (error && /fetch|network|relay/i.test(String(error.message || error.name || ''))) return { ok: false, code: 'auth_offline' };
      return { ok: true };
    } catch (e) {
      return { ok: false, code: authErrorCode(e) };
    }
  }

  async function updatePassword(password) {
    const c = sb();
    if (!c) return { ok: false, code: 'auth_unavailable' };
    if (String(password || '').length < MIN_PASSWORD) return { ok: false, code: 'auth_pw_short' };
    const session = await getSession();
    if (!session) return { ok: false, code: 'auth_no_session' };
    try {
      const { error } = await c.auth.updateUser({ password });
      // Si ya era su contraseña no hay nada que cambiar: se trata como guardada y entra.
      if (error && (error.code === 'same_password' || /different from the old password/i.test(String(error.message || '')))) return { ok: true };
      if (error) return { ok: false, code: authErrorCode(error) === 'auth_bad' ? 'err_unknown' : authErrorCode(error) };
      return { ok: true };
    } catch (e) {
      return { ok: false, code: authErrorCode(e) };
    }
  }

  // Borra todo lo que el comprador deja en el navegador: cestas, borradores, empresa, tienda,
  // clave de idempotencia y avisos entre páginas. No toca el idioma.
  function clearOrderStorage() {
    try {
      Object.keys(localStorage).forEach((k) => {
        if (k.startsWith('ses_order_draft_v1') || k.startsWith('ses_b2b_draft_req:') || k === 'ses_order_pending_v1' || k === 'ses_draft_code_v1') localStorage.removeItem(k);
      });
    } catch (_) { /* almacenamiento bloqueado */ }
    try {
      Object.keys(sessionStorage).forEach((k) => { if (k.startsWith('ses_b2b_') || k.startsWith(AUTH_STORAGE_KEY)) sessionStorage.removeItem(k); });
    } catch (_) { /* almacenamiento bloqueado */ }
  }

  // Salir siempre funciona: aunque la red o Supabase fallen, se borra la sesión local y se recarga
  // la página (fuera catálogo, precios y diálogos de memoria). Espera como mucho 3 s al servidor.
  let signingOut = false;
  async function signOut() {
    if (signingOut) return;
    signingOut = true;
    const c = sb();
    meCache = null;
    clearOrderStorage();
    document.querySelectorAll('.ses-b2b').forEach((el) => { el.setAttribute('aria-busy', 'true'); el.style.visibility = 'hidden'; });
    try {
      if (c) {
        try { if (c.auth.stopAutoRefresh) await c.auth.stopAutoRefresh(); } catch (_) { /* sigue */ }
        await Promise.race([
          Promise.resolve(c.auth.signOut({ scope: 'local' })).catch(() => null),
          new Promise((resolve) => setTimeout(resolve, 3000)),
        ]);
      }
    } catch (_) {
      /* la limpieza local de abajo se hace igual */
    } finally {
      clearOrderStorage(); // por si algún aviso de SIGNED_OUT volvió a guardar algo
      location.replace(location.pathname);
    }
  }

  /* ---------- RPC y consultas ---------- */
  function errorCode(error) {
    if (!error) return null;
    const msg = String(error.message || error || '');
    const first = msg.trim().split(/[\s:]/)[0];
    if (ERROR_CODES.includes(first)) return first;
    if (error.code === 'PGRST301' || error.code === '401' || /jwt/i.test(msg)) return 'session_expired';
    if (/failed to fetch|networkerror|load failed|network/i.test(msg)) return 'network';
    return 'unknown';
  }
  function errorMessage(code) { return t('err_' + (code || 'unknown')); }

  async function rpc(name, args) {
    const c = sb();
    if (!c) return { data: null, error: { message: 'network' }, code: 'network' };
    try {
      const { data, error } = await c.rpc(name, args || {});
      if (error) return { data: null, error, code: errorCode(error), detail: error.details || null };
      return { data, error: null, code: null };
    } catch (e) {
      return { data: null, error: e, code: errorCode(e) };
    }
  }

  // Trae todas las filas de una consulta paginando de 1000 en 1000 (límite de PostgREST).
  async function selectAll(build) {
    const out = [];
    const page = 1000;
    for (let from = 0; from < 50000; from += page) {
      const { data, error } = await build().range(from, from + page - 1);
      if (error) throw error;
      out.push(...(data || []));
      if (!data || data.length < page) break;
    }
    return out;
  }

  let meCache = null;
  async function me(force) {
    if (meCache && !force) return meCache;
    const r = await rpc('portal_me');
    if (r.error) throw Object.assign(new Error(r.code), { code: r.code });
    meCache = await applyViewAs(r.data || { companies: [] });
    return meCache;
  }

  function chosenCompanyId(meData) {
    const list = (meData && meData.companies) || [];
    if (!list.length) return null;
    const saved = ssGet(COMPANY_KEY);
    if (saved && list.some((c) => c.id === saved)) return saved;
    return list.length === 1 ? list[0].id : null;
  }
  function chooseCompany(id) { if (id) ssSet(COMPANY_KEY, id); else ssDel(COMPANY_KEY); }
  // Vista «todos los hoteles» de un administrador de grupo (portal_me.groups); null si no aplica.
  function chosenGroupId(meData) {
    const groups = (meData && meData.groups) || [];
    const saved = ssGet(GROUP_KEY);
    return saved && groups.some((g) => g.id === saved) ? saved : null;
  }
  function chooseGroup(id) { if (id) ssSet(GROUP_KEY, id); else ssDel(GROUP_KEY); }

  /* ---------- «Ver como…» (solo administradores de SES) ----------
     El admin elige una empresa y ve el portal y el catálogo como su comprador: la empresa sustituye a las
     suyas en me.companies con can_order=true y view_as=true. Puede guardar borradores y enviar pedidos en su
     nombre (portal_save_draft/portal_submit usan can_place_order(), que admite al admin); lo demás que exige
     can_order() en el servidor (recepciones, reportes de venta, datos de facturación) sigue cerrado y el front
     lo oculta con view_as. Lee por el «or is_admin()» de las políticas; las descargas se registran a su nombre
     (portal_log_download guarda auth.uid()). La elección vive en sessionStorage, por pestaña. */
  async function applyViewAs(data) {
    const id = vaGet();
    if (!id) return data;
    if (!data.is_admin) { vaDel(); return data; }
    let co = null;
    try {
      const { data: rows, error } = await sb().from('portal_companies')
        .select('id,name,legal_name,portal_stores(id,name,country_code,enabled)').eq('id', id).eq('enabled', true).limit(1);
      if (!error && rows && rows[0]) co = rows[0];
    } catch (_) { co = null; }
    if (!co) { vaDel(); return data; }
    const stores = (co.portal_stores || []).filter((st) => st.enabled)
      .map((st) => ({ id: st.id, name: st.name, country_code: st.country_code }))
      .sort((x, y) => String(x.name).localeCompare(String(y.name)));
    const viewAs = { id: co.id, name: co.name, legal_name: co.legal_name, can_order: true, can_see_documents: true, stores, view_as: true };
    ssSet(COMPANY_KEY, co.id);
    ssDel(GROUP_KEY);
    // «Ver como» muestra una sola empresa: nunca la vista de grupo del propio admin.
    return Object.assign({}, data, { companies: [viewAs], groups: [], view_as: viewAs });
  }
  function setViewAs(id) {
    meCache = null;
    if (id) { vaSet(id); ssSet(COMPANY_KEY, id); } else { vaDel(); ssDel(COMPANY_KEY); }
  }
  async function adminCompanies() {
    const rows = await selectAll(() => sb().from('portal_companies').select('id,name').eq('enabled', true).order('name').order('id'));
    return rows.sort((x, y) => String(x.name).localeCompare(String(y.name), locale(), { sensitivity: 'base' }));
  }
  const fold = (v) => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  // Selector con buscador, agrupado por inicial. Resuelve con el id elegido o null.
  async function pickViewAs(o) {
    const opts = o || {};
    let list;
    try { list = await adminCompanies(); }
    catch (e) { toast(errorMessage(errorCode(e)), 'err', { root: opts.root }); return null; }
    const uid = 'va' + Math.random().toString(36).slice(2, 7);
    const body = document.createElement('div');
    body.className = 'b2b-viewas';
    body.innerHTML = `<p class="b2b-dialog-text b2b-viewas-help">${esc(t('va_help'))}</p>
      <label class="b2b-label" for="${uid}">${esc(t('va_search'))}</label>
      <input id="${uid}" class="b2b-input" type="search" autocomplete="off" spellcheck="false" autofocus>
      <p class="b2b-viewas-count" role="status" aria-live="polite"></p>
      <div class="b2b-viewas-list"></div>`;
    const input = body.querySelector('input');
    const box = body.querySelector('.b2b-viewas-list');
    const count = body.querySelector('.b2b-viewas-count');
    const current = vaGet();
    function paint() {
      const qy = fold(input.value.trim());
      const hits = list.filter((c) => !qy || fold(c.name).includes(qy));
      count.textContent = hits.length ? t('va_count', { n: fmtInt(hits.length) }) : t('va_none');
      const groups = new Map();
      hits.forEach((c) => {
        const k = (fold(c.name).match(/[a-z0-9]/) || ['#'])[0].toUpperCase();
        if (!groups.has(k)) groups.set(k, []);
        groups.get(k).push(c);
      });
      box.innerHTML = [...groups].map(([k, cs]) => `<p class="b2b-viewas-letter" aria-hidden="true">${esc(k)}</p>
        <ul class="b2b-viewas-group" role="list">${cs.map((c) => `<li><button type="button" class="b2b-viewas-item${c.id === current ? ' is-current' : ''}" data-action="co:${esc(c.id)}"${c.id === current ? ' aria-current="true"' : ''}>${esc(c.name)}</button></li>`).join('')}</ul>`).join('');
    }
    input.addEventListener('input', paint);
    input.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const first = box.querySelector('[data-action]');
      if (first) { e.preventDefault(); first.click(); }
    });
    paint();
    const res = await dialog({ title: t('va_title'), body, root: opts.root, wide: false });
    return res && res.indexOf('co:') === 0 ? res.slice(3) : null;
  }

  // Franja «Viendo como: Empresa · solo lectura» bajo la barra. Sin vista activa, la quita.
  function paintViewAs(meData, o) {
    const opts = o || {};
    const root = opts.root || rootEl();
    let el = root.querySelector('.b2b-viewas-banner');
    const va = meData && meData.view_as;
    if (!va) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'b2b-viewas-banner';
      el.setAttribute('role', 'region');
      const bar = root.querySelector('.b2b-bar');
      if (bar) bar.insertAdjacentElement('afterend', el); else root.prepend(el);
    }
    el.setAttribute('aria-label', t('va_banner'));
    el.innerHTML = `${ICON.eye}<p class="b2b-viewas-text"><span>${esc(t('va_banner'))}:</span> <strong>${esc(va.name)}</strong> <span class="b2b-viewas-ro">· ${esc(t('va_on_behalf'))}</span></p>
      <div class="b2b-viewas-actions">
        <button type="button" class="b2b-btn b2b-btn--ghost" data-va="change">${esc(t('va_change'))}</button>
        <button type="button" class="b2b-btn b2b-btn--secondary" data-va="exit">${esc(t('va_exit'))}</button>
      </div>`;
    el.querySelector('[data-va="exit"]').addEventListener('click', () => { setViewAs(null); if (opts.onChange) opts.onChange(null); });
    el.querySelector('[data-va="change"]').addEventListener('click', async () => {
      const id = await pickViewAs({ root });
      if (!id) return;
      setViewAs(id);
      if (opts.onChange) opts.onChange(id);
    });
  }

  // Edge Function con la sesión del comprador. Devuelve { data, code }; el código sale del cuerpo JSON
  // de error ({error:'forbidden'}) o de la red.
  async function invokeFn(name, body) {
    const c = sb();
    if (!c || !c.functions) return { data: null, code: 'network' };
    try {
      const { data, error } = await c.functions.invoke(name, { body: body || {} });
      if (!error) return { data, code: null };
      let code = null;
      try {
        const ctx = error.context;
        const j = ctx && typeof ctx.json === 'function' ? await ctx.json() : null;
        code = j && (j.error || j.code) ? String(j.error || j.code) : null;
        if (!code && ctx && ctx.status === 401) code = 'session_expired';
      } catch (_) { code = null; }
      if (!code) code = /fetch|network|relay/i.test(String(error.message || error.name || '')) ? 'network' : 'unknown';
      if (code === 'unauthorized') code = 'session_expired';
      return { data: null, code: ERROR_CODES.includes(code) || DICT['err_' + code] ? code : 'unknown' };
    } catch (e) {
      return { data: null, code: errorCode(e) };
    }
  }

  /* ---------- foco y diálogos ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function focusables(el) {
    return Array.from(el.querySelectorAll(FOCUSABLE)).filter((n) => n.offsetParent !== null || n === document.activeElement);
  }
  // Mantiene el Tab dentro de `el`. Devuelve la función que lo suelta.
  function trapFocus(el, onEscape) {
    function onKey(e) {
      if (e.key === 'Escape' && onEscape) { e.preventDefault(); onEscape(); return; }
      if (e.key !== 'Tab') return;
      const f = focusables(el);
      if (!f.length) { e.preventDefault(); return; }
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !el.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }

  function rootEl() {
    return document.querySelector('.ses-b2b') || document.body;
  }

  let scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.classList.toggle('b2b-scroll-lock', scrollLocks > 0);
  }

  // Diálogo genérico. actions: [{ id, label, kind: 'primary'|'secondary'|'ghost'|'danger' }].
  // Resuelve con el id pulsado, o null si se cierra.
  function dialog(opts) {
    const o = opts || {};
    return new Promise((resolve) => {
      const prev = document.activeElement;
      const wrap = document.createElement('div');
      wrap.className = 'b2b-dialog-wrap';
      const titleId = 'b2bdlg' + Math.random().toString(36).slice(2, 8);
      wrap.innerHTML = `
        <div class="b2b-dialog${o.wide ? ' b2b-dialog--wide' : ''}" role="${o.alert ? 'alertdialog' : 'dialog'}" aria-modal="true" aria-labelledby="${titleId}">
          <div class="b2b-dialog-head">
            <h2 class="b2b-dialog-title" id="${titleId}">${esc(o.title || '')}</h2>
            ${o.dismissible === false ? '' : `<button type="button" class="b2b-icon-btn" data-close aria-label="${esc(t('close'))}">${ICON.close}</button>`}
          </div>
          <div class="b2b-dialog-body"></div>
          <div class="b2b-dialog-foot">
            ${(o.actions || []).map((a) => `<button type="button" class="b2b-btn b2b-btn--${a.kind || 'secondary'}" data-action="${esc(a.id)}">${esc(a.label)}</button>`).join('')}
          </div>
        </div>`;
      const body = wrap.querySelector('.b2b-dialog-body');
      if (o.body instanceof Node) body.appendChild(o.body);
      else body.innerHTML = o.body || '';
      if (!(o.actions || []).length) wrap.querySelector('.b2b-dialog-foot').remove();
      (o.root || rootEl()).appendChild(wrap);
      lockScroll(true);
      let release = null;
      function done(val) {
        if (release) release();
        lockScroll(false);
        wrap.remove();
        if (prev && prev.focus && document.contains(prev)) prev.focus();
        resolve(val);
      }
      release = trapFocus(wrap, o.dismissible === false ? null : () => done(null));
      wrap.addEventListener('click', (e) => {
        if (e.target === wrap && o.dismissible !== false) { done(null); return; }
        const close = e.target.closest('[data-close]');
        if (close) { done(null); return; }
        const act = e.target.closest('[data-action]');
        if (act) done(act.dataset.action);
      });
      if (o.onMount) o.onMount(wrap.querySelector('.b2b-dialog'), done);
      const autof = wrap.querySelector('[autofocus]') || wrap.querySelector('[data-action]') || focusables(wrap)[0];
      if (autof) autof.focus();
    });
  }

  function confirmDialog(o) {
    return dialog({
      title: o.title, body: `<p class="b2b-dialog-text">${esc(o.text || '')}</p>`, alert: true, root: o.root,
      actions: [{ id: 'cancel', label: o.cancelLabel || t('cancel'), kind: 'ghost' },
        { id: 'ok', label: o.okLabel || t('ok'), kind: o.danger ? 'danger' : 'primary' }],
    }).then((r) => r === 'ok');
  }

  /* ---------- avisos ---------- */
  let toastTimer = null;
  function toast(msg, kind, opts) {
    const root = (opts && opts.root) || rootEl();
    let el = root.querySelector(':scope > .b2b-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'b2b-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      root.appendChild(el);
    }
    el.className = 'b2b-toast' + (kind ? ' b2b-toast--' + kind : '');
    el.innerHTML = '';
    const p = document.createElement('div');
    p.className = 'b2b-toast-msg';
    p.textContent = msg;
    el.appendChild(p);
    if (opts && opts.list && opts.list.length) {
      const ul = document.createElement('ul');
      ul.className = 'b2b-toast-list';
      opts.list.slice(0, 12).forEach((s) => { const li = document.createElement('li'); li.textContent = s; ul.appendChild(li); });
      if (opts.list.length > 12) { const li = document.createElement('li'); li.textContent = '…'; ul.appendChild(li); }
      el.appendChild(ul);
    }
    if (opts && opts.link) {
      const a = document.createElement('a');
      a.className = 'b2b-toast-link';
      a.href = opts.link.href;
      a.textContent = opts.link.label;
      el.appendChild(a);
    }
    const x = document.createElement('button');
    x.type = 'button';
    x.className = 'b2b-toast-x';
    x.setAttribute('aria-label', t('close'));
    x.innerHTML = ICON.close;
    x.addEventListener('click', () => { el.hidden = true; });
    el.appendChild(x);
    el.hidden = false;
    clearTimeout(toastTimer);
    const ms = (opts && opts.ms) || (kind === 'err' ? 9000 : (opts && (opts.list || opts.link) ? 9000 : 4500));
    toastTimer = setTimeout(() => { el.hidden = true; }, ms);
  }

  /* ---------- iconos (trazo 1.5, mismo lenguaje) ---------- */
  const svg = (d, extra) => `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"${extra || ''}>${d}</svg>`;
  const ICON = {
    close: svg('<path d="M6 6l12 12M18 6L6 18"/>'),
    chev: svg('<path d="M9 5l7 7-7 7"/>'),
    user: svg('<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/>'),
    logout: svg('<path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4"/><path d="M10 17l-5-5 5-5M5 12h11"/>'),
    lock: svg('<rect x="5" y="11" width="14" height="9" rx="1"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>'),
    eye: svg('<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>'),
    bag: svg('<path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>'),
    up: svg('<path d="M12 19V5M6 11l6-6 6 6"/>'),
    down: svg('<path d="M12 5v14M6 13l6 6 6-6"/>'),
    plus: svg('<path d="M12 5v14M5 12h14"/>'),
    minus: svg('<path d="M5 12h14"/>'),
    x: svg('<path d="M7 7l10 10M17 7L7 17"/>'),
    doc: svg('<path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5"/>'),
    download: svg('<path d="M12 4v11M7 10l5 5 5-5M5 20h14"/>'),
    check: svg('<path d="M5 12l5 5 9-10"/>'),
    clock: svg('<circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/>'),
    repeat: svg('<path d="M4 12a8 8 0 0 1 14-5.3L20 9"/><path d="M20 4v5h-5"/><path d="M20 12a8 8 0 0 1-14 5.3L4 15"/><path d="M4 20v-5h5"/>'),
    arrowLeft: svg('<path d="M19 12H5M11 6l-6 6 6 6"/>'),
    alert: svg('<path d="M12 4l9 16H3z"/><path d="M12 10v4M12 17v.5"/>'),
    search: svg('<circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5"/>'),
  };

  /* ---------- formularios de acceso ---------- */
  // mode: 'login' | 'forgot' | 'set'. onDone(result) al entrar o guardar contraseña.
  function renderAuthForm(container, opts) {
    const o = opts || {};
    let mode = o.mode || 'login';
    let notice = o.notice || '';
    let noticeKind = o.noticeKind || 'info';
    let emailVal = '';

    function field(id, label, type, ac, extra) {
      return `<div class="b2b-field">
        <label class="b2b-label" for="${id}">${esc(label)}</label>
        <div class="b2b-input-wrap">
          <input class="b2b-input" id="${id}" name="${id}" type="${type}" autocomplete="${ac}" ${extra || ''} />
          ${type === 'password' ? `<button type="button" class="b2b-pw-toggle" data-pw-toggle="${id}" aria-label="${esc(t('auth_show_pw'))}" aria-pressed="false">${esc(t('auth_show'))}</button>` : ''}
        </div>
      </div>`;
    }

    function draw() {
      const uid = 'a' + Math.random().toString(36).slice(2, 7);
      let html = '';
      if (mode === 'login') {
        html = `
          <p class="b2b-auth-intro">${esc(t('auth_intro'))}</p>
          <div class="b2b-auth-notice" role="alert" ${notice ? '' : 'hidden'} data-kind="${noticeKind}">${esc(notice)}</div>
          <form class="b2b-auth-form" novalidate>
            ${field(uid + 'e', t('auth_email'), 'email', 'username', 'inputmode="email" autocapitalize="off" spellcheck="false" required')}
            ${field(uid + 'p', t('auth_password'), 'password', 'current-password', 'required')}
            <button type="submit" class="b2b-btn b2b-btn--primary b2b-btn--block">${esc(t('auth_submit'))}</button>
          </form>
          <div class="b2b-auth-links">
            <button type="button" class="b2b-link" data-mode="forgot">${esc(t('auth_forgot'))}</button>
            <a class="b2b-link" href="${ACCESS_MAILTO}">${esc(t('auth_request'))}</a>
          </div>`;
      } else if (mode === 'forgot') {
        html = `
          ${o.hideSub ? '' : `<h3 class="b2b-auth-sub">${esc(t('auth_forgot_title'))}</h3>`}
          <p class="b2b-auth-intro">${esc(t('auth_forgot_help'))}</p>
          <div class="b2b-auth-notice" role="alert" ${notice ? '' : 'hidden'} data-kind="${noticeKind}">${esc(notice)}</div>
          <form class="b2b-auth-form" novalidate>
            ${field(uid + 'e', t('auth_email'), 'email', 'username', 'inputmode="email" autocapitalize="off" spellcheck="false" required')}
            <button type="submit" class="b2b-btn b2b-btn--primary b2b-btn--block">${esc(t('auth_forgot_send'))}</button>
          </form>
          <div class="b2b-auth-links">
            <button type="button" class="b2b-link" data-mode="login">${esc(t('auth_back'))}</button>
          </div>`;
      } else {
        html = `
          ${o.hideSub ? '' : `<h3 class="b2b-auth-sub">${esc(t('auth_set_title'))}</h3>`}
          <p class="b2b-auth-intro">${esc(t('auth_set_help'))}</p>
          <div class="b2b-auth-notice" role="alert" ${notice ? '' : 'hidden'} data-kind="${noticeKind}">${esc(notice)}</div>
          <form class="b2b-auth-form" novalidate>
            ${field(uid + 'n', t('auth_new_pw'), 'password', 'new-password', `minlength="${MIN_PASSWORD}" required`)}
            ${field(uid + 'r', t('auth_new_pw2'), 'password', 'new-password', `minlength="${MIN_PASSWORD}" required`)}
            <button type="submit" class="b2b-btn b2b-btn--primary b2b-btn--block">${esc(t('auth_set_save'))}</button>
          </form>`;
      }
      container.innerHTML = html;
      const emailInput = container.querySelector('input[type="email"]');
      if (emailInput && emailVal) emailInput.value = emailVal;
      container.querySelectorAll('[data-mode]').forEach((b) => b.addEventListener('click', () => {
        const ei = container.querySelector('input[type="email"]');
        if (ei) emailVal = ei.value;
        mode = b.dataset.mode; notice = ''; draw();
      }));
      container.querySelectorAll('[data-pw-toggle]').forEach((b) => b.addEventListener('click', () => {
        const inp = container.querySelector('#' + b.dataset.pwToggle);
        const show = inp.type === 'password';
        inp.type = show ? 'text' : 'password';
        b.textContent = show ? t('auth_hide') : t('auth_show');
        b.setAttribute('aria-pressed', show ? 'true' : 'false');
      }));
      container.querySelector('form').addEventListener('submit', onSubmit);
      const first = container.querySelector('input');
      // foco inicial en el email, salvo que el usuario ya esté escribiendo en el formulario
      if (first && o.autofocus !== false) {
        setTimeout(() => {
          const act = document.activeElement;
          if (!act || act === document.body || !container.contains(act)) first.focus();
        }, 0);
      }
    }

    function showNotice(msg, kind) {
      const n = container.querySelector('.b2b-auth-notice');
      if (!n) return;
      n.textContent = msg;
      n.dataset.kind = kind || 'err';
      n.hidden = !msg;
    }

    async function onSubmit(e) {
      e.preventDefault();
      const form = e.currentTarget;
      const btn = form.querySelector('button[type="submit"]');
      const inputs = form.querySelectorAll('input');
      const label = btn.textContent;
      const busy = (on) => { btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); btn.textContent = on ? t('auth_signing') : label; };
      if (mode === 'login') {
        const email = inputs[0].value.trim();
        const pw = inputs[1].value;
        if (!email || !pw) { showNotice(t('auth_need')); (email ? inputs[1] : inputs[0]).focus(); return; }
        if (!isValidEmail(email)) { showNotice(t('auth_email_bad')); inputs[0].focus(); return; }
        busy(true);
        const r = await signIn(email, pw);
        busy(false);
        if (!r.ok) { showNotice(t(r.code)); inputs[1].value = ''; inputs[1].focus(); return; }
        if (o.onDone) o.onDone({ mode: 'login' });
      } else if (mode === 'forgot') {
        const email = inputs[0].value.trim();
        if (!isValidEmail(email)) { showNotice(t('auth_email_bad')); inputs[0].focus(); return; }
        busy(true);
        const r = await requestReset(email);
        busy(false);
        if (!r.ok) { showNotice(t(r.code)); return; }
        emailVal = email;
        showNotice(t('auth_forgot_sent'), 'ok');
        btn.disabled = true;
      } else {
        const a = inputs[0].value;
        const b = inputs[1].value;
        if (a.length < MIN_PASSWORD) { showNotice(t('auth_pw_short')); inputs[0].focus(); return; }
        if (a !== b) { showNotice(t('auth_pw_mismatch')); inputs[1].focus(); return; }
        busy(true);
        const r = await updatePassword(a);
        busy(false);
        if (!r.ok) { showNotice(t(r.code)); return; }
        if (o.onDone) o.onDone({ mode: 'set' });
      }
    }

    draw();
    return { redraw: draw, setMode(m, msg, kind) { mode = m; notice = msg || ''; noticeKind = kind || 'err'; draw(); } };
  }

  // Login en diálogo (página de pedidos). Resuelve true si entra.
  function openLogin(opts) {
    const o = opts || {};
    return new Promise((resolve) => {
      let ok = false;
      const body = document.createElement('div');
      body.className = 'b2b-auth';
      dialog({
        title: t('auth_title'), body, root: o.root,
        onMount: (_box, done) => {
          renderAuthForm(body, { mode: o.mode || 'login', notice: o.notice, onDone: () => { ok = true; done('ok'); } });
        },
      }).then(() => resolve(ok));
    });
  }

  /* ---------- barra B2B ---------- */
  // Pinta la barra superior compartida: idiomas + hueco de cuenta.
  // opts: { page: 'order'|'portal', portalUrl, orderUrl, onLogin, onLogout }
  function mountBar(bar, opts) {
    if (!bar) return null;
    const o = opts || {};
    const langBox = bar.querySelector('.b2b-lang');
    const acc = bar.querySelector('.b2b-account');
    const tag = bar.querySelector('.b2b-bar-tag');
    // en el móvil los cuatro botones se cambian por un selector nativo (CSS decide cuál se ve)
    let pick = null;
    if (langBox && !bar.querySelector('.b2b-lang-pick')) {
      const wrap = document.createElement('span');
      wrap.className = 'b2b-lang-pick';
      wrap.innerHTML = `<select>${LANGS.map((l) => `<option value="${l}" lang="${l}">${l.toUpperCase()}</option>`).join('')}</select>`;
      langBox.after(wrap);
      pick = wrap.querySelector('select');
      pick.addEventListener('change', () => setLang(pick.value));
    }
    function paintLang() {
      if (langBox) {
        langBox.setAttribute('aria-label', t('lang_group'));
        langBox.querySelectorAll('[data-lang]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.lang === lang ? 'true' : 'false'));
      }
      if (pick) { pick.value = lang; pick.setAttribute('aria-label', t('lang_group')); }
      if (tag) tag.textContent = t('wholesale_tag');
    }
    if (langBox) langBox.querySelectorAll('[data-lang]').forEach((b) => b.addEventListener('click', () => setLang(b.dataset.lang)));
    let session = null;
    function paintAccount() {
      if (!acc) return;
      if (!session) {
        // sin sesión la página entera es la pantalla de acceso: la barra solo lleva logo e idiomas
        acc.innerHTML = '';
      } else {
        const main = o.page === 'portal'
          ? `<a class="b2b-bar-btn" href="${esc(o.orderUrl || '/pages/venta-wholesale')}">${ICON.bag}<span>${esc(t('acc_order'))}</span></a>`
          : `<a class="b2b-bar-btn" href="${esc(o.portalUrl || '/pages/b2b-cuenta')}">${ICON.user}<span>${esc(t('acc_account'))}</span></a>`;
        acc.innerHTML = `${main}<button type="button" class="b2b-bar-btn b2b-bar-btn--quiet" data-acc="logout">${ICON.logout}<span>${esc(t('acc_logout'))}</span></button>`;
      }
      const lb = acc.querySelector('[data-acc="login"]');
      if (lb) lb.addEventListener('click', () => o.onLogin && o.onLogin());
      const lo = acc.querySelector('[data-acc="logout"]');
      if (lo) lo.addEventListener('click', async () => { await signOut(); if (o.onLogout) o.onLogout(); });
    }
    onLang(() => { paintLang(); paintAccount(); });
    paintLang();
    paintAccount();
    return { setSession(s) { session = s; paintAccount(); }, repaint() { paintLang(); paintAccount(); } };
  }

  let settingsPromise = null;
  async function publishedSettings() {
    if (!settingsPromise) settingsPromise = (async () => {
      try {
        const result = await sb().from('portal_settings').select('payload,revision').eq('id', true).maybeSingle();
        if (result.error || !result.data) return null;
        const value = result.data.payload || {};
        const texts = {};
        for (const [key, translations] of Object.entries(value.texts || {})) {
          if (key.startsWith('gr_') && translations && typeof translations === 'object') texts[key] = translations;
        }
        extend(texts);
        return value;
      } catch (_) { settingsPromise = null; return null; }
    })();
    return settingsPromise;
  }


  /* ---------- datos de facturación de la empresa: aviso discreto y utilidades ----------
     Completo = razón social + NIF/VAT + calle + CP + ciudad + país (portal_companies.billing_missing, calculado
     en Supabase). Sin billing_synced_at el CRM aún no los ha publicado: no se avisa. Las solicitudes que envía
     el comprador (portal_company_detail_requests) las revisa SES; los datos oficiales no cambian hasta entonces. */
  extend({
    bn_missing:  { es: 'Faltan tus datos de facturación', en: 'Your billing details are incomplete', fr: 'Vos données de facturation sont incomplètes', it: 'Mancano i tuoi dati di fatturazione' },
    bn_complete: { es: 'Completar', en: 'Complete', fr: 'Compléter', it: 'Completa' },
    bn_pending:  { es: 'Datos de facturación recibidos · pendientes de revisión', en: 'Billing details received · pending review', fr: 'Données de facturation reçues · en cours de vérification', it: 'Dati di fatturazione ricevuti · in revisione' },
    bn_view:     { es: 'Ver', en: 'View', fr: 'Voir', it: 'Vedi' },
    bn_close:    { es: 'Ocultar este aviso', en: 'Hide this notice', fr: 'Masquer cet avis', it: 'Nascondi questo avviso' },
    err_invalid_details: { es: 'Hay datos con un formato no válido. Revisa los campos marcados.', en: 'Some details have an invalid format. Check the highlighted fields.', fr: 'Certaines données ont un format non valide. Vérifiez les champs signalés.', it: 'Alcuni dati hanno un formato non valido. Controlla i campi evidenziati.' },
    err_missing_fields:  { es: 'Faltan datos obligatorios. Revisa los campos marcados.', en: 'Some required details are missing. Check the highlighted fields.', fr: 'Des données obligatoires manquent. Vérifiez les champs signalés.', it: 'Mancano dati obbligatori. Controlla i campi evidenziati.' },
    err_too_many_versions: { es: 'Has enviado demasiadas correcciones. Escríbenos y lo revisamos.', en: 'Too many corrections sent. Contact us and we will review it.', fr: 'Trop de corrections envoyées. Contactez-nous.', it: 'Troppe correzioni inviate. Scrivici e lo controlliamo.' },
    err_invalid_idempotency_key: { es: 'No se pudo enviar. Recarga la página y vuelve a intentarlo.', en: 'It could not be sent. Reload the page and try again.', fr: 'Envoi impossible. Rechargez la page et réessayez.', it: 'Invio non riuscito. Ricarica la pagina e riprova.' },
  });

  const BILL_COLS = 'id,name,legal_name,tax_id,billing_street,billing_number,billing_postcode,billing_city,billing_province,' +
    'billing_country,billing_country_code,billing_contact_name,billing_email,billing_synced_at,billing_missing';
  const BILL_REQ_COLS = 'id,company_id,status,version,details,submitted_by_email,submitted_at,crm_status,ses_note,resolved_at';
  const BILL_FIELDS = ['legal_name', 'tax_id', 'street', 'number', 'postcode', 'city', 'province', 'country', 'contact_name', 'email'];
  const BILL_REQUIRED = ['legal_name', 'tax_id', 'street', 'postcode', 'city', 'country'];
  const BILL_MAX = { legal_name: 200, tax_id: 20, street: 200, number: 20, postcode: 12, city: 100, province: 100, country: 2, contact_name: 200, email: 254 };
  // ISO-3166 alfa-2 (249 códigos)
  const COUNTRY_CODES = ('ADAEAFAGAIALAMAOAQARASATAUAWAXAZBABBBDBEBFBGBHBIBJBLBMBNBOBQBRBSBTBVBWBYBZCACCCDCFCGCHCICKCLCMCNCOCRCU' +
    'CVCWCXCYCZDEDJDKDMDODZECEEEGEHERESETFIFJFKFMFOFRGAGBGDGEGFGGGHGIGLGMGNGPGQGRGSGTGUGWGYHKHMHNHRHTHUIDIEILIMINIOIQIRISITJE' +
    'JMJOJPKEKGKHKIKMKNKPKRKWKYKZLALBLCLILKLRLSLTLULVLYMAMCMDMEMFMGMHMKMLMMMNMOMPMQMRMSMTMUMVMWMXMYMZNANCNENFNGNINLNONPNRNUNZ' +
    'OMPAPEPFPGPHPKPLPMPNPRPSPTPWPYQARERORSRURWSASBSCSDSESGSHSISJSKSLSMSNSOSRSSSTSVSXSYSZTCTDTFTGTHTJTKTLTMTNTOTRTTTVTWTZUAUG' +
    'UMUSUYUZVAVCVEVGVIVNVUWFWSYEYTZAZMZW').match(/../g);
  const foldTxt = (v) => String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/gi, ' ').trim().toLowerCase();
  let countryIndex = null;
  // Código ISO a partir del texto libre del CRM ("Spain", "España", "ESPAÑA", "PT"…); null si no se reconoce.
  function countryCodeFor(name) {
    const raw = String(name || '').trim();
    if (!raw) return null;
    if (/^[a-z]{2}$/i.test(raw) && COUNTRY_CODES.includes(raw.toUpperCase())) return raw.toUpperCase();
    if (!countryIndex) {
      countryIndex = new Map();
      ['en', 'es', 'fr', 'it', 'pt', 'de'].forEach((l) => {
        let dn = null;
        try { dn = new Intl.DisplayNames([l], { type: 'region' }); } catch (_) { dn = null; }
        if (dn) COUNTRY_CODES.forEach((c) => { const k = foldTxt(dn.of(c)); if (k && !countryIndex.has(k)) countryIndex.set(k, c); });
      });
      [['uk', 'GB'], ['united states of america', 'US'], ['usa', 'US'], ['uae', 'AE'], ['emiratos arabes unidos', 'AE']]
        .forEach(([k, c]) => countryIndex.set(k, c));
    }
    return countryIndex.get(foldTxt(raw)) || null;
  }
  // Opciones del selector de país, ordenadas por el nombre en el idioma actual.
  function countryOptions() {
    return COUNTRY_CODES.map((c) => ({ code: c, name: countryName(c) || c }))
      .sort((a, b) => a.name.localeCompare(b.name, locale(), { sensitivity: 'base' }));
  }
  // Datos oficiales (CRM) en el formato del formulario.
  function officialDetails(co) {
    co = co || {};
    return {
      legal_name: co.legal_name || '', tax_id: co.tax_id || '', street: co.billing_street || '', number: co.billing_number || '',
      postcode: co.billing_postcode || '', city: co.billing_city || '', province: co.billing_province || '',
      country: co.billing_country_code || countryCodeFor(co.billing_country) || '',
      contact_name: co.billing_contact_name || '', email: co.billing_email || '',
    };
  }
  // Misma normalización que portal_submit_company_details; quita los vacíos.
  function normalizeDetails(raw) {
    const out = {};
    BILL_FIELDS.forEach((k) => {
      let v = String((raw && raw[k]) == null ? '' : raw[k]).trim().replace(/\s+/g, ' ');
      if (k === 'tax_id') v = v.toUpperCase().replace(/[\s./-]/g, '');
      else if (k === 'country') v = v.toUpperCase();
      else if (k === 'email') v = v.toLowerCase();
      if (v) out[k] = v;
    });
    return out;
  }
  // { campo: 'required' | 'format' | 'email' | 'length' } (vacío si todo está bien)
  function validateDetails(d) {
    const err = {};
    BILL_REQUIRED.forEach((k) => { if (!d[k]) err[k] = 'required'; });
    Object.keys(d).forEach((k) => { if (!err[k] && BILL_MAX[k] && d[k].length > BILL_MAX[k]) err[k] = 'length'; });
    if (d.legal_name && !err.legal_name && d.legal_name.length < 2) err.legal_name = 'length';
    if (d.tax_id && !err.tax_id && !/^[A-Z0-9]{4,20}$/.test(d.tax_id)) err.tax_id = 'format';
    if (d.postcode && !err.postcode && !/^[A-Za-z0-9][A-Za-z0-9 -]{1,11}$/.test(d.postcode)) err.postcode = 'format';
    if (d.country && !COUNTRY_CODES.includes(d.country)) err.country = 'required';
    if (d.email && !err.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.email)) err.email = 'email';
    return err;
  }
  function billingKind(company, request) {
    const missing = Array.isArray(company.billing_missing) ? company.billing_missing : [];
    const incomplete = !!company.billing_synced_at && missing.length > 0;
    const synced = parseDate(company.billing_synced_at);
    const resolved = request && parseDate(request.resolved_at);
    // APPLIED en el CRM pero aún sin publicar: sigue «pendiente» hasta que lleguen los datos nuevos
    const pending = !!request && (request.status === 'PENDING' ||
      (request.status === 'APPLIED' && (!synced || (resolved && resolved > synced))));
    return { company, request, missing, incomplete, pending, kind: incomplete ? (pending ? 'pending' : 'missing') : null };
  }
  const billCache = new Map();
  // Estado de la empresa: { company, request, missing, incomplete, pending, kind }; null si no se puede saber
  // (sin conexión o sin las columnas nuevas): entonces no se avisa.
  function billingState(companyId, force) {
    if (!companyId) return Promise.resolve(null);
    if (!force && billCache.has(companyId)) return billCache.get(companyId);
    const p = (async () => {
      const c = sb();
      if (!c) return null;
      const [co, rq] = await Promise.all([
        c.from('portal_companies').select(BILL_COLS).eq('id', companyId).limit(1),
        c.from('portal_company_detail_requests').select(BILL_REQ_COLS).eq('company_id', companyId)
          .order('submitted_at', { ascending: false }).limit(1),
      ]);
      if (co.error || !co.data || !co.data[0]) return null;
      return billingKind(co.data[0], (!rq.error && rq.data && rq.data[0]) || null);
    })().catch(() => null);
    billCache.set(companyId, p);
    p.then((v) => { if (v === null && billCache.get(companyId) === p) billCache.delete(companyId); });
    return p;
  }
  // Tras enviar: la solicitud nueva sustituye a la anterior en la caché (sin esperar a recargar).
  function setBillingRequest(companyId, request) {
    const prev = billCache.get(companyId);
    if (!prev) return;
    billCache.set(companyId, prev.then((st) => (st ? billingKind(st.company, request) : st)));
  }
  const hideKey = (kind, companyId) => `ses_b2b_billnote_hidden:${kind}:${companyId}`;
  // Pinta (o vacía) el aviso en `slot`. opts: { companyId, href, focusAfter }; sin opts lo oculta.
  function mountBillingNotice(slot, opts) {
    if (!slot) return Promise.resolve(null);
    const seq = (slot._bnSeq = (slot._bnSeq || 0) + 1);
    const clear = () => { slot.hidden = true; slot.innerHTML = ''; slot._bnKey = null; };
    if (!opts || !opts.companyId) { clear(); return Promise.resolve(null); }
    return billingState(opts.companyId).then((st) => {
      if (slot._bnSeq !== seq) return st;
      if (!st || !st.kind || ssGet(hideKey(st.kind, opts.companyId))) { clear(); return st; }
      // mismo aviso ya pintado: no se repinta (un lector de pantalla no lo vuelve a anunciar)
      const key = [opts.companyId, st.kind, lang, opts.href || ''].join('|');
      if (!slot.hidden && slot._bnKey === key && slot.firstElementChild) return st;
      slot._bnKey = key;
      const pending = st.kind === 'pending';
      slot.innerHTML = `<div class="b2b-billnote${pending ? ' b2b-billnote--pending' : ''}" role="status" data-kind="${st.kind}">
        <p class="b2b-billnote-text">${esc(t(pending ? 'bn_pending' : 'bn_missing'))}</p>
        ${opts.href ? `<a class="b2b-billnote-link" href="${esc(opts.href)}">${esc(t(pending ? 'bn_view' : 'bn_complete'))}<span class="b2b-billnote-arrow" aria-hidden="true">→</span></a>` : ''}
        <button type="button" class="b2b-billnote-close" aria-label="${esc(t('bn_close'))}">${ICON.close || '×'}</button>
      </div>`;
      slot.hidden = false;
      slot.querySelector('.b2b-billnote-close').addEventListener('click', () => {
        ssSet(hideKey(st.kind, opts.companyId), '1');
        clear();
        const f = opts.focusAfter;
        if (f && f.focus) {
          if (!f.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(f.tagName)) f.setAttribute('tabindex', '-1');
          f.focus({ preventScroll: true });
        }
      });
      return st;
    });
  }
  const billing = {
    FIELDS: BILL_FIELDS, REQUIRED: BILL_REQUIRED, MAX: BILL_MAX, COUNTRY_CODES,
    countryCodeFor, countryOptions, officialDetails, normalizeDetails, validateDetails,
    state: billingState, setRequest: setBillingRequest, mount: mountBillingNotice,
  };

  window.SESB2B = {
    LANGS, LOCALES, MIN_PASSWORD, ACCESS_MAILTO, ICON,
    t, extend, has, getLang, setLang, onLang, locale,
    esc, safeHex, safeUrl, fmtPrice, fmtAmount, fmtInt, fmtDate, fmtDateTime, countryName, uuid, isValidEmail,
    sb, getSession, onAuth, signIn, signOut, clearOrderStorage, requestReset, updatePassword,
    rpc, selectAll, me, errorCode, errorMessage, invokeFn, cleanAuthUrl,
    chosenCompanyId, chooseCompany, chosenGroupId, chooseGroup, setViewAs, pickViewAs, paintViewAs,
    authRedirect, needsPassword,
    trapFocus, dialog, confirmDialog, toast, lockScroll,
    renderAuthForm, openLogin, mountBar, publishedSettings,
    ss: { get: ssGet, set: ssSet, del: ssDel }, ls: { get: lsGet, set: lsSet },
    billing,
  };
})();
